import { useEffect } from 'react';

import { WidgetViewMode } from 'utilitys/reporting/widgetViewModeUtils';

import { UseBaseTable } from 'hooks/useBaseTable';
import { DEFAULT_ERROR, useCustomSnackBar } from 'hooks/useCustomSnackBar';

import { useUpdateIfReady } from 'components/Dashboards/Reporting/widgetInReport/hooks/RefreshWidgetPayload/useUpdateIfReady';
import { UseActivitiesPredecessorsProvider } from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors.provider';
import { generateTabs } from 'components/widgets/ActivityCompletionPlan/ActivitiesPredecessors.utils';

interface Props {
    ui: UseActivitiesPredecessorsProvider['ui'];
    api: UseActivitiesPredecessorsProvider['api'];
    title: string;
    subTitle: string;
    latestVersionId: number | undefined;
    table: UseBaseTable['table'];
    setIsPayloadReady?: (newValue: boolean) => void;
    widgetViewMode?: WidgetViewMode;
}

export const useActivitiesPredecessorsLogic = ({
    ui,
    api,
    title,
    subTitle,
    table,
    setIsPayloadReady,
    widgetViewMode,
}: Props) => {
    const isPayloadReady = () => {
        const currentPayload = api.getActivityCompletionPlan.payload;
        if (!currentPayload) return;
        if (
            currentPayload.metaDataId === undefined ||
            currentPayload.contractId === undefined ||
            currentPayload.contractId === null
        ) {
            return;
        }
        setIsPayloadReady && setIsPayloadReady(true);
    };

    const { handleSnackBar } = useCustomSnackBar();
    useUpdateIfReady({ isPayloadReadyCallback: isPayloadReady, widgetViewMode: widgetViewMode });
    const handleAPICsvExport = () => {
        api.exportCompletionPlanToCsv.instance.mutate(
            { ...api.exportCompletionPlanToCsv.payload, fileName: `${title}_${subTitle}` },
            {
                onSuccess: () => {
                    handleSnackBar('File Successfully Downloaded', 'success');
                },
                onError: (error) => {
                    DEFAULT_ERROR({ error, handleError: handleSnackBar });
                },
            },
        );
    };

    const tabsArrData = generateTabs({ data: api.getActivityCompletionPlan.instance.data });

    useEffect(() => {
        if (api.getActivityCompletionPlan.instance.data) {
            table.setTotalPages(api.getActivityCompletionPlan.instance.data.numOfPages);
        }
    }, [api.getActivityCompletionPlan.instance.data]);

    //  reset Pagination on sorting and new filter request
    useEffect(() => {
        table.setPagination({ ...table.pagination, page: 1 });
    }, [
        table.sorting,
        ui.state.isCriticalPath,
        ui.state.activityTypeFilter,
        ui.state.statusFilter,
        ui.state.activeTab,
        ui.state.isDelayDriver,
        ui.state.submittedCompletionFilter,
    ]);

    return {
        logic: {
            tabsArrData,
            handleAPICsvExport,
        },
    };
};
